import { Handle, Position } from '@xyflow/react'
import { selectedBorder } from '../selectedBorder.js'

/**
 * RuleLogicNode — AND / OR in a transition rule graph, keyed by node type
 * (`ruleAnd` / `ruleOr`). Two boolean inputs `a` and `b`, one output. An
 * unwired input reads as false (RuleEvaluator), so a half-wired AND never
 * passes and a half-wired OR is just its wired input. Chain them for more than
 * two conditions. Same pill shape as NOT, a different colour per operator.
 */
const OP = {
  ruleAnd: { label: 'AND', fg: '#80b0e0', border: '#305070', borderSel: '#4080c0', bg: '#121a22', bgSel: '#1a2430' },
  ruleOr:  { label: 'OR',  fg: '#a0d080', border: '#3a6030', borderSel: '#60a040', bg: '#141c10', bgSel: '#1c2818' },
}

export function RuleLogicNode({ type, selected }) {
  const op = OP[type] ?? OP.ruleAnd
  const pin = { background: op.borderSel, width: 10, height: 10 }
  return (
    <div style={{
      background: selected ? op.bgSel : op.bg,
      border: `2px solid ${selected ? selectedBorder(op.border) : op.border}`,
      borderRadius: 20,
      padding: '12px 22px',
      color: op.fg,
      fontFamily: 'var(--m-font)',
      fontSize: 13,
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      position: 'relative',
    }}>
      <Handle type="target" position={Position.Left} id="a" style={{ ...pin, top: '30%' }} />
      <Handle type="target" position={Position.Left} id="b" style={{ ...pin, top: '70%' }} />
      {op.label}
      <Handle type="source" position={Position.Right} id="out" style={pin} />
    </div>
  )
}
